import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ThemeToggle from './ThemeToggle';
import WordmarkLogo from './WordmarkLogo';

const SOLUTIONS = [
  ['/solutions/safety', 'Safety & Civic'],
  ['/solutions/energy', 'Energy & Grid'],
  ['/solutions/agriculture', 'Agriculture'],
  ['/solutions/health', 'Health'],
  ['/solutions/fintech', 'Fintech'],
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const isLoggedIn = useSelector(s => !!s.auth?.accessToken);

  return (
    <nav className="nav">
      <div className="nav-inner">
        <WordmarkLogo size={22} linkTo="/" onClick={() => setMenuOpen(false)} />

        {/* Desktop nav */}
        <div className="nav-links nav-desktop">
          <a href="/#platform">Platform</a>
          <a href="/#pricing">Pricing</a>
          <div className="nav-dropdown">
            <span>Solutions</span>
            <div className="nav-dropdown-menu">
              {SOLUTIONS.map(([href, label]) => (
                <Link key={href} to={href}>{label}</Link>
              ))}
            </div>
          </div>
          <Link to="/developers">Developers</Link>
          <Link to="/docs">Docs</Link>
        </div>

        <div className="nav-cta nav-desktop">
          <ThemeToggle />
          {isLoggedIn ? (
            <>
              <Link to="/chat" className="nav-link-sm">Chat</Link>
              <Link to="/dashboard" className="btn btn-primary">
                Dashboard
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M2 5h6m0 0L5 2m3 3L5 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                </svg>
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link-sm">Sign in</Link>
              <Link to="/signup" className="btn btn-primary">
                Get started
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M2 5h6m0 0L5 2m3 3L5 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                </svg>
              </Link>
            </>
          )}
        </div>

        {/* Mobile right */}
        <div className="nav-mobile-right">
          <ThemeToggle />
          <button className="hamburger" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              {menuOpen ? (
                <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              ) : (
                <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="nav-mobile-menu" onClick={() => setMenuOpen(false)}>
          <a href="/#platform">Platform</a>
          <a href="/#pricing">Pricing</a>
          <div style={{ padding: '8px 0', borderTop: '1px solid var(--line)', marginTop: 4 }}>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--fg-dim)', letterSpacing: '0.1em', textTransform: 'uppercase', padding: '4px 0 8px' }}>Solutions</div>
            {SOLUTIONS.map(([href, label]) => (
              <Link key={href} to={href} style={{ display: 'block', padding: '7px 0', fontSize: 14, color: 'var(--fg-mid)' }}>{label}</Link>
            ))}
          </div>
          <Link to="/developers" style={{ borderTop: '1px solid var(--line)', paddingTop: 12 }}>Developers</Link>
          <Link to="/docs">Docs</Link>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, paddingTop: 16, borderTop: '1px solid var(--line)', marginTop: 8 }}>
            {isLoggedIn ? (
              <>
                <Link to="/chat" className="btn btn-ghost" style={{ justifyContent: 'center' }}>Chat</Link>
                <Link to="/dashboard" className="btn btn-primary" style={{ justifyContent: 'center' }}>Dashboard</Link>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost" style={{ justifyContent: 'center' }}>Sign in</Link>
                <Link to="/signup" className="btn btn-primary" style={{ justifyContent: 'center' }}>Get started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
